import {
  getQualitativeMeasureUrl,
  updateQualitativeMeasureUrl,
} from "../config/Config";
import { deleteRequest, postRequest, putRequest } from "./ServiceHelper";

export class QualitativeMeasureService {
  static createMeasure = (measure) => {
    return postRequest(getQualitativeMeasureUrl(), measure);
  };

  static updateMeasure = (measure) => {
    const measureId = measure.qualitativeMeasure.id
      ? measure.qualitativeMeasure.id
      : measure.qualitativeMeasure.ddl_id;
    return putRequest(updateQualitativeMeasureUrl(measureId), measure);
  };

  static deleteMeasure = (measureId) => {
    return deleteRequest(updateQualitativeMeasureUrl(measureId));
  };
}
